<template>
    <div
        class="modal fade modal-upload"
        :id="modalId"
        data-keyboard="false"
        data-backdrop="static"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <!-- Modal body -->
                <div class="modal-body">
                    <button type="button" class="close" data-dismiss="modal" @click="chkFileCnt()">&times;</button>

                        <div class="drag-box" v-if="isInitial" @drop.prevent="dropFile" @dragover.prevent>
                            <div class="d-flex align-items-center justify-content-center">
                                <i class="fa fa-cloud-upload mr-2" aria-hidden="true"></i>
                                {{$t('voucher.upload.drop_files_here')}}
                            </div>
                        </div>
                        <div class="box-list-upload">
                            <div class="mt-3 font500 d-flex align-items-center" v-for="(file, i) in uploadFiles" :key="i">
                                <div class="col-6 text-truncate">{{file.name}}</div>
                                <div class="col-6" v-if="beforeCnt == 0">
                                    <button class="btn btn-delete d-inline-flex" @click="deleteImage(i)">{{$t('button.delete')}}</button>
                                </div>
                            </div>
                        </div>
                        <div v-if="this.uploadFiles.length" class="mt-3">
                            <p class="d-inline-flex text-red text-truncate col-12" v-if="fileSize > constants.Upload.maxSize">{{$t('voucher.upload.max_size')}}</p>
                            <p class="d-inline-flex text-red text-truncate col-12" v-if="numFile > constants.Upload.maxFile">{{$t('voucher.upload.max_file')}}</p>
                        </div>

                        <div class="row mb-3 mt-3">
                            <div :class="this.uploadFiles.length ? 'col-6' : 'col-12 mt-4'">
                                <label :class="this.uploadFiles.length ? 'btn btn-upload-img w-100' : 'btn btn-upload-img w-50 m-auto'">
                                    <i class="fa fa-file mr-2" aria-hidden="true"></i>
                                    <form enctype="multipart/form-data" v-if="isInitial || isSaving">
                                        <input
                                            type="file"
                                            id="files"
                                            ref="files"
                                            accept="image/jpeg, image/png, image/jpg, image/tif, image/tiff, application/pdf, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                                            application/vnd.ms-powerpoint, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel.sheet.macroEnabled.12"
                                            multiple
                                            @change="handleSelectFile"
                                        />
                                    </form>
                                    {{$t('voucher.upload.select_files')}}
                                </label>
                            </div>
                            <div v-if="this.uploadFiles.length" class="col-6">
                                <button class="btn btn-submit w-100" @click="showPreviewFiles()" :disabled="disable">
                                    <i class="fa fa-upload mr-2" aria-hidden="true"></i>
                                    {{$t('button.upload')}}
                                </button>
                            </div>
                        </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Constants } from "@/helpers/constants";
import VoucherService from "@/services/module/voucher.service";
import StorageService from "@/services/common/storage.service";
import {AuthService} from "@/services/common/auth.service";
import Utils from '@/helpers/utils';

export default {
    name: "PcSelectFileModal",
    props: {
        modalId: {
            type: String,
            default: "uploadFileModal",
        },
        previewFiles: Function,
        setListFiles: Function,
        afterCheckPwdPdf: Function,
        uploadFiles: "",
        beforeCnt: 0,
    },
    components: {},
    data () {
        return {
            disable: false,
            constants: Constants,
            currentStatus: null,
            fileSize: 0,
            numFile: 0,
        };
    },
    beforeMount () {
    },
    updated () {
    },
    computed: {
        isInitial () {
            return this.currentStatus === 0;
        },
        isSaving () {
            return this.currentStatus === 1;
        },
    },
    methods: {
        dropFile (e) {
            let droppedFiles = e.dataTransfer.files;
            this.currentStatus = 0;
            let files = this.uploadFiles;
            if (files.length) {
                for (let index = 0; index < droppedFiles.length; index++) {
                    let has = false;
                    for (let i = 0; i < files.length; i++) {
                        if (files[i].name == droppedFiles[index].name) {
                            has = true;
                        }
                    }
                    if (!has) {
                        // files.push(droppedFiles[index]);
                        files = [...files, droppedFiles[index]];
                    }
                }
            } else {
                for (let index = 0; index < droppedFiles.length; index++) {
                    // files.push(droppedFiles[index]);
                    files = [...files, droppedFiles[index]];
                }
            }
            this.numFile = files.length;
            this.setListFiles(files);
            if (files.length) {
                this.fileSize = 0;
                this.disable = false;
                for (let i = 0; i < files.length; i++) {
                    this.fileSize = this.fileSize + files[i].size;
                }
                if (this.fileSize > this.constants.Upload.maxSize) {
                    this.disable = true;
                }
                if (this.numFile > this.constants.Upload.maxFile) {
                    this.disable = true;
                }
            } else {
                this.disable = true;
            }
        },
        reset () {
            // reset form to initial state
            this.currentStatus = 0;
        },
        deleteImage (id) {
            this.uploadFiles.splice(id, 1);
            if (this.uploadFiles.length) {
                this.fileSize = 0;
                this.disable = false;
                for (let i = 0; i < this.uploadFiles.length; i++) {
                    this.fileSize = this.fileSize + this.uploadFiles[i].size;
                }
                this.numFile = this.uploadFiles.length;
                if (this.fileSize > this.constants.Upload.maxSize) {
                    this.disable = true;
                }
                if (this.numFile > this.constants.Upload.maxFile) {
                    this.disable = true;
                }
            } else {
                this.disable = true;
            }
            this.reset();
        },
        handleSelectFile (e) {
            this.currentStatus = 0;
            let files = this.uploadFiles;
            if (files.length) {
                for (let index = 0; index < this.$refs.files.files.length; index++) {
                    let has = false;
                    for (let i = 0; i < files.length; i++) {
                        if (files[i].name == this.$refs.files.files[index].name) {
                            has = true;
                        }
                    }
                    if (!has) {
                        // files.push(this.$refs.files.files[index]);
                        files = [...files, this.$refs.files.files[index]];
                    }
                }
            } else {
                for (let index = 0; index < this.$refs.files.files.length; index++) {
                    // files.push(this.$refs.files.files[index]);
                    files = [...files, this.$refs.files.files[index]];
                }
            }
            this.numFile = files.length;
            this.setListFiles(files);
            if (files.length) {
                this.fileSize = 0;
                this.disable = false;
                for (let i = 0; i < files.length; i++) {
                    this.fileSize = this.fileSize + files[i].size;
                }
                if (this.fileSize > this.constants.Upload.maxSize) {
                    this.disable = true;
                }
                if (this.numFile > this.constants.Upload.maxFile) {
                    this.disable = true;
                }
            } else {
                this.disable = true;
            }
            // Reset input file
            e.target.value = '';
        },
        showPreviewFiles () {
            if (!this.uploadFiles || !this.uploadFiles.length) {
                return
            }
            this.getFormData().then(formD => {
                return VoucherService.checkPwdPdf(formD).then(response => {
                    return { response, formD };
                });
            })
                .then(({ response, formD }) => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    }
                    if (response.status != 200) {
                        let errorCode = Utils.getErrorCode(response);
                        let msg = this.$root.$t("fail.ocr_timeout");
                        if (errorCode) {
                            msg = this.$root.$t("error.error_code_" + errorCode);
                        }
                        this.$toasted.error(msg, {});
                    } else {
                        if (this.afterCheckPwdPdf) {
                            return this.afterCheckPwdPdf(formD);
                        } else {
                            return this.previewFiles();
                        }
                    }
                })
                .catch(error => {
                    let msg = this.$root.$t("error.error_unknown");
                    this.$toasted.error(msg, {});
                });
        },
        async getFormData () {
            let formData = new FormData();
            for (var i = 0; i < this.uploadFiles.length; i++) {
                let file = this.uploadFiles[i];
                formData.append('files', file);
                formData.append('filePath', file.name);
                formData.append('extend', 'pdf');
                formData.append('csrfToken', Utils.generateRandomString());
            }
            return formData;
        },
        chkFileCnt () {
            const diffCnt = this.uploadFiles.length - this.beforeCnt;
            if (diffCnt > 0) {
                for (let i = 0; i < diffCnt; i++) {
                    this.uploadFiles.pop();
                };
            };
        }
    },
    mounted () {
        this.reset();
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/pc/Voucher/UploadFileModal.vue